import React from "react";

const MuteIcon = (props: any) => {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        fill="var(--color-icon-bright)"
        stroke="var(--color-icon-bright)"
        d="m6.166 5.48.008-.005L8.606 3.95h.001c1.126-.702 2.108-.768 2.826-.37.719.398 1.184 1.262 1.184 2.596v.8c0 .03-.012.061-.038.087a.124.124 0 0 1-.087.038.123.123 0 0 1-.087-.038.123.123 0 0 1-.038-.087v-.8c0-1.006-.305-1.961-1.06-2.372-.75-.416-1.713-.175-2.572.365L6.302 5.685l-.009.005a1.72 1.72 0 0 1-.935.27H4.167c-.715 0-1.344.149-1.785.59-.44.44-.59 1.07-.59 1.784v3.334c0 .714.15 1.344.59 1.784.44.441 1.07.59 1.785.59h1.667c.03 0 .061.013.087.039a.124.124 0 0 1 .038.087c0 .03-.013.061-.038.087a.123.123 0 0 1-.087.038H4.167c-.92 0-1.557-.252-1.965-.66-.409-.409-.66-1.046-.66-1.965V8.334c0-.919.251-1.556.66-1.965.408-.408 1.046-.66 1.965-.66h1.192c.291 0 .571-.088.807-.23ZM8.617 16.045a.123.123 0 0 1-.043-.17.123.123 0 0 1 .169-.042l.003.002c.854.528 1.82.781 2.573.361.75-.417 1.056-1.367 1.056-2.37v-3.033c0-.03.013-.061.038-.087a.124.124 0 0 1 .087-.038c.03 0 .062.012.087.038a.123.123 0 0 1 .038.087v3.033c0 1.322-.47 2.196-1.18 2.595a2.087 2.087 0 0 1-.986.239c-.542 0-1.176-.194-1.841-.615Z"
      />
      <path
        fill="var(--color-icon-bright)"
        d="M15 13.959a.625.625 0 0 1-.5-1 4.939 4.939 0 0 0 .6-4.867.625.625 0 0 1 1.15-.483 6.213 6.213 0 0 1-.75 6.108.631.631 0 0 1-.5.242Z"
      />
      <path
        fill="var(--color-icon-bright)"
        d="M16.525 16.04a.625.625 0 0 1-.5-1 8.44 8.44 0 0 0 1.025-8.3.625.625 0 0 1 1.15-.483 9.682 9.682 0 0 1-1.175 9.533.605.605 0 0 1-.5.25ZM1.667 18.958a.618.618 0 0 1-.442-.184.629.629 0 0 1 0-.883L17.892 1.224a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .884L2.11 18.774a.618.618 0 0 1-.442.184Z"
      />
    </svg>
  );
};

export default MuteIcon;
